import { FilteredCreditApplication, RequiredDocumentWithStatus } from '@applyonline/shared'
import { EApplicantType } from '@if/core/types'
import { applicantFullName, hasApplicantIncomePendingReview } from '../../../../../data/credit-application-selectors'
import { useTranslation } from 'react-i18next'
import CreditStep, { CreditStepStatus } from './CreditStep'

interface IncomeCreditStepProps {
  creditApp: FilteredCreditApplication
  applicantType: EApplicantType
  skipBankAccountRequiredDocuments: RequiredDocumentWithStatus[]
  noConnector?: boolean
}

const IncomeCreditStep = ({
  creditApp,
  applicantType,
  skipBankAccountRequiredDocuments,
  noConnector,
}: IncomeCreditStepProps) => {
  const { t } = useTranslation()
  const applicant = applicantType === EApplicantType.Applicant ? creditApp.applicant : creditApp.coapplicant!
  const title = t('overview.incomeStep', { name: applicantFullName(applicant) })

  const areIncomePendingReview = hasApplicantIncomePendingReview(
    creditApp,
    applicantType,
    skipBankAccountRequiredDocuments,
  )

  const status =
    applicant.areIncomesConfirmed || areIncomePendingReview
      ? CreditStepStatus.Completed
      : CreditStepStatus.RequiresAttention

  const description =
    applicant.hasSkippedIncomeValidation && applicant.areIncomesConfirmed
      ? 'overview.incomeSkipped'
      : applicant.areIncomesConfirmed
        ? 'overview.incomeConfirmed'
        : areIncomePendingReview
          ? 'overview.incomeReview'
          : 'overview.incomeVerify'

  return (
    <CreditStep
      status={status}
      noConnector={noConnector}
      linkToDetail={`${applicantType.toLowerCase()}-incomes`}
      hideLinkToDetail={status === CreditStepStatus.Completed}
      title={title}
      content={t(description)}
    />
  )
}

export default IncomeCreditStep
